import type { NodeType, ResolvedPos } from "prosemirror-model";

export const isInBlock = (blockType: NodeType, $pos: ResolvedPos) => {
  for (let i = 0; i <= $pos.depth; ++i) {
    if ($pos.node(i).type === blockType) {
      return true;
    }
  }
  return false;
};
